import { formatISO } from "date-fns";

interface EliminationDetailUrlOptions {
    startDate?: Date | string;
    endDate?: Date | string;
    workspaceId?: string;
    consolidationGroupId?: string;
    accountCode?: number;
}

function toDateParam(value: Date | string): string {
    return typeof value === "string"
        ? value
        : formatISO(value, { representation: "date" });
}

export function buildEliminationDetailUrl({
    startDate,
    endDate,
    workspaceId,
    consolidationGroupId,
    accountCode,
}: EliminationDetailUrlOptions): string {
    const params = new URLSearchParams();

    if (startDate) {
        params.append("startDate", toDateParam(startDate));
    }
    if (endDate) {
        params.append("endDate", toDateParam(endDate));
    }
    if (workspaceId) {
        params.append("workspaceId", workspaceId);
    }
    if (consolidationGroupId) {
        params.append("consolidationGroupId", consolidationGroupId);
    }
    if (accountCode !== undefined) {
        params.append("accountCode", accountCode.toString());
    }

    return `/accounting/elimination-detail?${params.toString()}`;
}
